import React, { createContext, useContext } from 'react';
import useFetchHook from '../hooks/useFecthHook'; 

interface RedditPostData {
    id: string;
    title: string;
    author: string;
    url: string;
    created_utc: number;
    selftext: string;
}

interface RedditApiResponse {
    data: {
        children: {
            data: RedditPostData;
        }[];
    };
}

interface RedditPostDataContextType {
    data: RedditApiResponse['data'] | null;  
    loading: boolean;
    error: string | null;
}

export const RedditContext = createContext<RedditPostDataContextType | null>(null);

export function RedditProvider({ children }: { children: React.ReactNode }) {
  const { data, loading, error } = useFetchHook<RedditApiResponse>('https://www.reddit.com/r/technology/.json');

  return (
    <RedditContext.Provider value={{ data: data ? data.data : null, loading, error }}>
      {children}
    </RedditContext.Provider>
  );
}

export function useRedditContext() {
  const context = useContext(RedditContext);

  if (!context) {
    throw new Error('useRedditContext deve ser utilizado dentro de um RedditProvider!');
  }

  return context;
}
